import { render, staticRenderFns } from "./TooltipButton.vue?vue&type=template&id=96c23f86&scoped=true&"
import script from "./TooltipButton.vue?vue&type=script&lang=ts&"
export * from "./TooltipButton.vue?vue&type=script&lang=ts&"
import style0 from "./TooltipButton.vue?vue&type=style&index=0&id=96c23f86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96c23f86",
  null
  
)

export default component.exports